import { ReactElement } from 'react';

import Carousel from '@/components/shared/Carousel';
import styled, { css } from '@/styled';

interface IProps {
  className?: string;
  children?: ReactElement[] | ReactElement;
  withBorder?: boolean;
  title: string | ReactElement;
  carouselProps: {
    slidesToShow: number;
  };
}

const Shelf = ({ carouselProps, ...props }: IProps) => {
  return (
    <div className={props.className}>
      <div className='showcaseShelf-title'>{props.title}</div>
      <Carousel {...carouselProps}>{props.children}</Carousel>
    </div>
  );
};

export default styled(Shelf)(
  ({ theme, withBorder }) => css`
    .showcaseShelf-title {
      ${withBorder && `border-bottom: 1px solid ${theme.palette.alpha(theme.palette.gray[0], 0.12)}`};
      height: ${withBorder ? 42 : 24}px;
      margin-bottom: ${theme.space.spacing(6)};
      display: flex;
      align-items: center;
      & > h4 {
        font-weight: 400;
      }
    }

    & h3,
    h4 {
      margin: 0;
    }

    & a.ant-typography {
      min-width: 60px;
      margin-left: ${theme.space.spacing(6)};
    }
  `
);
